import PropTypes from "prop-types";
import HideIf from "util/HideIf";
import VizSensor from "../../design-system/VizSensor";
import styles from "./VideoThumbnail.module.scss";

const propTypes = {
  youtubeId: PropTypes.string,
  vimeoId: PropTypes.string,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  vimeoType: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
};

function VideoThumbnail({
  youtubeId,
  vimeoId,
  title,
  onSelect,
  vimeoType = false,
  thumbnailUrl,
}: any) {
  return (
    <div className={styles.video_thumbnail} onClick={() => onSelect(vimeoType ? vimeoId : youtubeId, vimeoType)}>
      <HideIf show={vimeoType}>
        <div className="m-t-15" />
      </HideIf>

      <HideIf show={!vimeoType}>
        <i className="fa fa-youtube-play" />
      </HideIf>

      <div className="media">

        <div className="media-left">

          <VizSensor forceSSR>
            <img alt="" src={thumbnailUrl} className={styles.video_thumbnail_image} />
          </VizSensor>
        </div>

        <div className="media-body">
          {title}
        </div>
      </div>
    </div>
  );
}

VideoThumbnail.propTypes = propTypes;

export default VideoThumbnail;
